import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { LeadService } from 'src/app/private/services/lead.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { format } from 'date-fns';
import { MettingService } from 'src/app/private/services/micro-services/metting.service';

@Component({
  selector: 'app-lead-meeting',
  imports: [FormsModule,ButtonModule,TextareaModule,InputTextModule,DatePickerModule,SharedModule],
  templateUrl: './lead-meeting.component.html',
  styleUrl: './lead-meeting.component.scss'
})
export class LeadMeetingComponent {
  @Output() closeDialog = new EventEmitter<any>();
  mettingTitle = '';
  mettngDate = '';
  mettingDescription = '';
  selectedDuration = '';
  selectedTimeSlots = '';
  timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  @Input() leadDetails : any;

  constructor(
    private api : LeadService,
    private localStorage : LocalStorageService,
    private messageService : MessageService,
    private mettingService : MettingService
  ) { }

  loading = false;
  isAdding = false;

  timeDurations :any[] = [
    {label :'15 Minutes',value : 15},
    {label :'30 Minutes',value : 30},
    {label :'45 Minutes',value : 45},
    {label :'1 Hour',value : 60},
  ]
  timeSlots :any[] = []

  today = new Date();

  handleSaveTask() {
   
    if(this.mettingTitle === '') {
      this.messageService.add({severity:'error', summary: 'Error', detail: 'Please enter meeting title'});
      return;
    }

    if(this.mettngDate === '') {
      this.messageService.add({severity:'error', summary: 'Error', detail: 'Please select meeting date'});
      return;
    }

    if(this.selectedDuration === '') {
      this.messageService.add({severity:'error', summary: 'Error', detail: 'Please select meeting duration'});
      return;
    }

    if(this.selectedTimeSlots === '') {
      this.messageService.add({severity:'error', summary: 'Error', detail: 'Please select meeting time'});
      return;
    }

    if(this.mettingDescription === '') {
      this.messageService.add({severity:'error', summary: 'Error', detail: 'Please enter meeting description'});
      return;
    }

    this.isAdding = true

    const payload : any = {
      startDate : format(new Date(this.mettngDate), 'dd/MM/yyyy'),
      inviteeEmails : [this.localStorage.getEmail() , this.leadDetails.email],
      timeZone : this.timeZone,
      duration : this.selectedDuration,
      meetingTime : this.selectedTimeSlots.split(' ')[0],
      meeting_title : this.mettingTitle,
      meeting_desc : this.mettingDescription,
      organization_id : this.localStorage.getOrganizationId(),
      lead_id : this.leadDetails.lead_id,
      assigned_to : this.leadDetails.assigned_to,
      user_id : this.localStorage.getUserId()
    }


    this.api.scheduleMeeting(payload).subscribe({
      next : (response:any) => {
        this.isAdding = false
        this.messageService.add({severity:'success', summary: 'Success', detail: 'Meeting scheduled successfully'});
        payload['meeting_link'] = response?.hangoutLink
        this.mettingService.addMeet(payload)
        this.mettingTitle = ''
        this.mettngDate = ''
        this.mettingDescription = ''
        this.selectedDuration = ''
        this.selectedTimeSlots = ''
        this.closeDialog.emit()
      },
      error : (error:any) => {
        this.isAdding = false
        console.log("error",error)
        this.messageService.add({severity:'error', summary: 'Error', detail: 'Something went wrong'});
      }
    }
    )
  }

  handleDurationChange(event:any) {

    this.timeSlots = []
    this.loading = true

    const payload = {
      startDate : format(new Date(this.mettngDate), 'dd/MM/yyyy'),
      inviteeEmails : [this.localStorage.getEmail() , this.leadDetails.email],
      timeZone : this.timeZone,
      duration : this.selectedDuration,
      organization_id : this.localStorage.getOrganizationId()
    }
    
    this.api.getAvailableTimeSlots(payload).subscribe({
      next : (response:any) => {
        this.loading = false
        this.timeSlots =  Array.isArray(response) ? response : []
      },
      error : (error:any) => {
        this.loading = false
        console.log("error",error)
      }
    }
    )

  }

  handleClosDialog() {
    this.closeDialog.emit()
  }
}
